import { useEffect, useRef } from 'react';
import { formatCurrency, formatDate } from '@recargas-dominicanas/core/utils';
import { Cell, Pagination, Table, TableHeader, TableRow, Text } from '@recargas-dominicanas/core/components';
import { useBusinessStore } from '../../../stores/businessStore';
import { style } from './balances.module.css';

export function Balances() {

  const businessStore = useBusinessStore();

  const tableRef = useRef<HTMLTableElement>(null);
  
  useEffect(() => {
    if (tableRef.current) tableRef.current.scrollTop = 0;
  }, [businessStore.balances]);

  async function handleFetchBalances(page: number, size: number) {
    await businessStore.fetchBalances(businessStore.business!.id, page, size);
  }

  if (!businessStore.balances) return null;

  return (
    <div className={style.container}>
      <div className={style.content}>
        <Table 
          style={style.table}
          refElement={tableRef}>
          <TableHeader style={style.tableHeader}>
            <Text text='Balance'/>
            <Text text='Fecha'/>
          </TableHeader>
          <tbody>
            {
              businessStore.balances.data.map(balance => (
                <TableRow key={balance.id} style={style.tableRow}>
                  <Cell text={formatDate(balance.date)}/>
                  <Cell text={formatCurrency(balance.amount)} color='green' weight='medium'/>
                </TableRow>
              ))
            }
          </tbody>
        </Table>
      </div>
      <Pagination
        title='Balances'
        index={businessStore.balances.index}
        pages={businessStore.balances.pages}
        count={businessStore.balances.count}
        size={businessStore.balances.size}
        onChange={handleFetchBalances}/>
    </div>
  );
}
